import PropTypes from 'prop-types';
import { Box, Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import ClientMasterIcon from '@/assets/icons/client-master-icon.svg?react';
import ClientRegularIcon from '@/assets/icons/client-regular-icon.svg?react';
import { userInfoFieldStyles } from '@/themes/commonStyles/user.js';

const StyledUserInfoField = styled(Box)(userInfoFieldStyles);

export const UserInfoField = ({ record }) => {
    if (!record) return null;
    const isMasterRole = record.role === 'ROLE_ADMIN' || record.role === 'ROLE_CLIENT_MASTER';

    return (
        <StyledUserInfoField>
            {isMasterRole ? <ClientMasterIcon /> : <ClientRegularIcon />}
            <Box>
                <Typography component='p' className='user-info-field-name'>
                    {record.firstName} {record.lastName}
                </Typography>
                <Box className='user-contact-info-container'>
                    {record.phone && (
                        <Typography component='p' className='user-info-field-phone'>
                            {record.phone}
                        </Typography>
                    )}
                    {record.email && (
                        <Link href={`mailto:${record.email}`} className='user-info-field-link'>
                            {record.email}
                        </Link>
                    )}
                </Box>
            </Box>
        </StyledUserInfoField>
    );
};

UserInfoField.propTypes = {
    record: PropTypes.shape({
        role: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string,
    }),
};
